

export const RavelUtilities = {

    convertHexToRgbaColor: function(hex, alpha) {
        // Remove the leading # if present
        hex = hex.replace(/^#/, '');

        // Parse 3-digit hex (e.g., #fff) into 6-digit form
        if (hex.length === 3) {
            hex = hex.split('').map(c => c + c).join('');
        }

        // Extract r, g, b
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

}